import { FC } from 'react';
import { css } from '@emotion/react';
import { spacing, colors } from '../../../styles';
import { ToolRendererProps } from './types';
import { LoadingState, EmptyCircleIcon } from './shared/LoadingState';
import { AverageIcon, FavorableIcon, DangerousIcon } from './shared/constants';

export const TodoListRenderer: FC<ToolRendererProps> = ({ output, isLoading }) => {
  if (isLoading) {
    return <LoadingState message="Updating task list..." />;
  }

  if (!output.todos || !Array.isArray(output.todos)) {
    if (output.message) {
      return <LoadingState message={output.message} />;
    }
    return <LoadingState message="Task list updated" />;
  }

  return (
    <div
      css={css`
        margin: ${spacing.centi} 0 0 0;
      `}
    >
      {output.todos.map((todo: any, index: number) => (
        <div
          key={todo.id || index}
          css={css`
            display: flex;
            align-items: flex-start;
            gap: ${spacing.centi};
            margin-bottom: ${spacing.centi};
            line-height: 1.4;
          `}
        >
          <div
            css={css`
              width: 16px;
              height: 16px;
              margin-top: 1px;
              flex-shrink: 0;
              display: flex;
              align-items: center;
              justify-content: center;
            `}
          >
            {todo.status === 'completed' ? (
              <img src={FavorableIcon} alt="completed" width="16" height="16" />
            ) : todo.status === 'in_progress' ? (
              <img src={AverageIcon} alt="in progress" width="16" height="16" />
            ) : todo.status === 'error' ? (
              <img src={DangerousIcon} alt="error" width="16" height="16" />
            ) : (
              <EmptyCircleIcon />
            )}
          </div>
          <span
            css={css`
              font-size: 14px;
              color: ${todo.status === 'completed' ? colors.silver : colors.liquorice};
              opacity: ${todo.status === 'completed' ? 0.7 : 1};

              html[data-theme='dark'] & {
                color: ${todo.status === 'completed' ? colors.silver : colors.sugar};
              }
            `}
          >
            {todo.content}
          </span>
        </div>
      ))}
    </div>
  );
};
